var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerimeterDistance = function SvgPerimeterDistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1,
    x: 1.395,
    y: 14.17,
    fill: "#000",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1,
    x: 1.395,
    y: 1.17,
    fill: "#000",
    rx: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.041 13.524a.5.5 0 0 0 .707 0l3.182-3.182a.5.5 0 0 0-.707-.708l-2.828 2.829-2.829-2.829a.5.5 0 1 0-.707.707zm.707-10.708a.5.5 0 0 0-.707 0L4.859 5.998a.5.5 0 1 0 .707.707l2.829-2.828 2.828 2.828a.5.5 0 1 0 .707-.707zm.147 10.354v-10h-1v10z"
  })));
};
export default SvgPerimeterDistance;